<template>
  <h1>
    Solicitud de
    {{ formatRequestType(requestDetail?.letterCertifConfig?.name || '') }}
  </h1>
  <br />
  <Fieldset class="w-11" :toggleable="true">
    <template #legend>
      <div class="flex align-items-center text-primary">
        <span class="text-base">Información del empleado</span>
      </div>
    </template>
    <div class="grid">
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Nombre:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.name
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Nómina:</label>
          <span class="pt-2 font-bold"
            >{{ requestDetail?.employee.payroll.code }} -
            {{ requestDetail?.employee.payroll.name }}</span
          >
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Numero de identificación:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee.identificationNumber
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">País de residencia:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.countryResidence
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Ciudad:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.cityResidence
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Teléfono primario:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.primaryPhone
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Sucursal:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.subsidiary
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Dirección:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.direction
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Gerencia:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.management
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Departamento:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.department
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Área:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.area
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Posición:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.position
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Turno:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.shift
          }}</span>
        </div>
      </div>
    </div>
  </Fieldset>
  <Fieldset class="w-11 mt-3 mb-4" :toggleable="true">
    <template #legend>
      <div class="flex align-items-center text-primary">
        <span class="text-base">Detalle de la solicitud</span>
      </div>
    </template>
    <div class="grid">
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Nombre de la carta:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.letterCertifConfig.name
          }}</span>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Estado de la solicitud:</label>
          <span class="pt-2 font-bold">{{
            formatRequestState(requestDetail?.status || '')
          }}</span>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Multiples aprobadores:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.hasManyApprovers ? 'Sí' : 'No'
          }}</span>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Fecha de resolución:</label>
          <span class="pt-2 font-bold" v-if="requestDetail?.resolutionDate">{{
            formatDate(String(requestDetail?.resolutionDate))
          }}</span>
        </div>
      </div>
      <template v-if="requestDetail?.urlFile">
        <div class="lg:col-4 md:col-6 col-12">
          <label class="text-base font-medium">Archivo generado:</label>
          <Button
            v-if="requestDetail?.urlFile"
            v-tooltip.bottom="'ver adjunto'"
            class="action-btn view hover:text-blue-800 mr-2 pt-2"
            severity="secondary"
            icon="pi pi-file"
            @click="downloadAttachment(requestDetail?.urlFile)"
          ></Button>
        </div>
      </template>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Fecha de generación:</label>
          <span class="pt-2 font-bold" v-if="requestDetail?.generationDate">{{
            formatDate(String(requestDetail?.generationDate))
          }}</span>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Fecha de creación:</label>
          <span class="pt-2 font-bold">{{
            formatDate(String(requestDetail?.createdAt))
          }}</span>
        </div>
      </div>
    </div>
  </Fieldset>
  <Footer>
    <ConfirmDialog group="templating"></ConfirmDialog>
    <Button
      class="mt-2 font-light h-2rem mr-2"
      label="volver"
      severity="secondary"
      @click="back"
    ></Button>
    <template v-if="isValidToAnswer">
      <Button
        class="mt-2 font-light h-2rem mr-2"
        label="Rechazar"
        severity="danger"
        @click="confirmResolution($event, 'REJECTED')"
      ></Button>
      <Button
        class="mt-2 font-light h-2rem"
        label="Aprobar"
        severity="success"
        @click="confirmResolution($event, 'APPROVED')"
      ></Button>
    </template>
  </Footer>
</template>
<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue'

  import { formatRequestType } from '@/shared/utils/formatRequestType'
  import { useRoute } from 'vue-router'
  import Footer from '@/shared/components/Footer.vue'
  import router from '@/router'
  import useNotifications from '@/store/notification'
  import useLoading from '@/store/load'
  import { useConfirm } from 'primevue/useconfirm'
  import { useUserStore } from '@/store/user'
  import { storeToRefs } from 'pinia'
  import { getFileUrlPresigned } from '@/shared/services/fileService'
  import { formatDate } from '@/shared/utils/formatDate'
  import LetterRequestDetail from '../models/LetterRequestDetail'
  import {
    createLetterRequestResolutions,
    getLetterRequestDetail,
  } from '../services/LetterRequestService'
  const path = useRoute()
  const requestDetail = ref<LetterRequestDetail>()
  const resolutionComment = ref<string>('')
  const notificationStore = useNotifications()
  const loadingStore = useLoading()
  const { user } = storeToRefs(useUserStore())
  const requestNotFoundModal = ref(false)
  const requestId = ref<string>()
  const from = ref<string>()

  onMounted(async () => {
    loadingStore.setLoadingState()
    requestId.value = String(path.params.id)
    from.value = String(path.params.from)

    requestDetail.value = await getLetterRequestDetail(requestId.value)
    if (!requestDetail.value) {
      requestNotFoundModal.value = true
    }
    loadingStore.dismissLoadingState()
  })

  const back = () => {
    router.push('/letterRequests/approver')
  }

  const confirm = useConfirm()

  const confirmResolution = (event: any, state: 'APPROVED' | 'REJECTED') => {
    confirm.require({
      group: 'templating',
      header: 'Confirmación',
      message: '¿Estas seguro de realizar esta acción?',
      icon: 'pi pi-exclamation-circle',
      acceptIcon: 'pi pi-check',
      acceptLabel: 'Confirmar',
      rejectIcon: 'pi pi-times',
      rejectLabel: 'Cancelar',
      rejectClass: 'p-button-sm',
      acceptClass: 'p-button-outlined p-button-sm',
      accept: async () => {
        await onResolutionRequest(state)
      },
      reject: () => {},
    })
  }

  const onResolutionRequest = async (state: 'APPROVED' | 'REJECTED') => {
    if (!user.value || !requestId.value) return
    loadingStore.setLoadingState()

    const response = await createLetterRequestResolutions({
      userId: user.value?.id,
      resolutions: [
        {
          letterRequestId: requestId.value,
          resolutionStatus: state,
        },
      ],
    })

    loadingStore.dismissLoadingState()

    if (response === 'OK') {
      notificationStore.addSuccesNotification({
        detail: `200`,
        severity: 'success',
        summary: `Solicitud ${
          state === 'APPROVED' ? 'aprobada' : 'rechazada'
        } exitosamente`,
      })

      router.push('/letterRequests/approver')
    }
  }

  const isValidToAnswer = computed(() => {
    return requestDetail.value?.status === 'PENDING'
  })

  const downloadAttachment = async (fileKey: string) => {
    if (!fileKey) return

    if (fileKey.includes('http')) {
      window.open(fileKey, '_blank')
      return
    }

    const fileUrl = await getFileUrlPresigned(fileKey)
    window.open(fileUrl, '_blank')
  }

  const formatRequestState = (state: string) => {
    switch (state) {
      case 'PENDING':
        return 'Pendiente'
      case 'REJECTED':
        return 'Rechazado'
      case 'APPROVED':
        return 'Aprobado'
      case 'GENERATED':
        return 'Generada'
      case 'ERROR_GENERATING':
        return 'Error al generar'
      default:
        return 'Pendiente'
    }
  }
</script>
<style scoped>
  tabla {
    margin-top: 1rem;
    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.1),
      0px 4px 5px -2px rgba(0, 0, 0, 0.12),
      0px 10px 15px -5px rgba(0, 0, 0, 0.2);
    border-radius: 16px;
    width: 90%;
  }

  :deep(.p-column-title) {
    font-size: 14px;
  }

  :deep(.p-datatable-tbody) {
    font-size: 14px;
  }

  .action-btn {
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
